import SFullPage from './style.module.scss';
import { WebPNextImage as Image } from '../../WebPImage';
import FadeIn from '../../commonComponents/fadeIn';
import ReactCompareImage from 'react-compare-image';
import { useEffect, useState } from 'react';
import { Button, Input, Upload, message, Spin } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import request from '@/utils/request/next-request';
import { useUserAgentInfo } from '../../../context/user-agent';
import { src } from '@/utils/common';

const HUMANMAT_TYPE = {
  FILE: '1', // 读取file参数作为输入图片
  URL: '2', // 读取URL参数作为输入图片
};
const ImageDemo = ({ data }) => {
  const [current, setCurrent] = useState(0);
  const [inputUrl, setInputUrl] = useState('');
  const [beforePic, setBeforePic] = useState('');
  const [afterPic, setAfterPic] = useState('');
  const [loading, setLoading] = useState(true);
  const { isMobile } = useUserAgentInfo();
  const [slider, setSlider] = useState(50);

  const beforeUpload = async (file, fileList) => {
    const res = await getHandleResult({
      typeId: HUMANMAT_TYPE.FILE,
      file,
    });
    if (res.code === 200) {
      setAfterPic(res.data.data);
      return true;
    } else {
      message.error('检测出错！');
    }
  };
  const getImage = async (fileObj) => {
    const reader = new FileReader();
    reader.readAsDataURL(fileObj.file);
    reader.onload = function () {
      setBeforePic(reader.result as string);
    };
  };

  useEffect(() => {
    setBeforePic(src(data.items[0].before));
    setAfterPic(src(data.items[0].after));
  }, []);

  const handleDemoClick = (index) => {
    setBeforePic(src(data.items[index].before));
    setAfterPic(src(data.items[index].after));
    setCurrent(index);
  };

  const onSearch = async () => {
    if (inputUrl) {
      const res = await getHandleResult({
        typeId: HUMANMAT_TYPE.URL,
        url: inputUrl,
      });
      if (res.code === 200) {
        setBeforePic(inputUrl);
        setAfterPic(res.data.data);
      } else {
        message.error('检测出错！');
      }
    }
  };

  const getHandleResult = async ({
    typeId,
    url,
    file,
  }: {
    typeId: string;
    url?: string;
    file?: File;
  }) => {
    setLoading(true);
    try {
      const forms = new FormData();
      forms.append('config[alpha_png]', 'true');
      forms.append('typeId', typeId);
      if (typeId === HUMANMAT_TYPE.URL) {
        forms.append('url', inputUrl);
      } else {
        forms.append('file', file);
      }
      const res = await request({
        url: `${process.env.NEXT_PUBLIC_YTECH_URL}/effects/streamlake_humanmat`,
        method: 'POST',
        headers: { 'content-type': 'multipart/form-data' },
        data: forms,
      });
      return res;
    } catch (err) {
      message.error('检测出错！');
    } finally {
      setLoading(false);
    }
  };
  const handelChange = (e) => {
    setInputUrl(e.target.value);
  };

  const sliderChange = (value) => {
    setSlider(value * 100);
  };

  const imageLoaded = () => {
    setLoading(false);
  };
  return (
    <>
      {!isMobile ? (
        <div className={SFullPage['section']}>
          <FadeIn>
            <div className={SFullPage['title']}>{data.title}</div>
          </FadeIn>
          <div className={SFullPage['container']}>
            <div className={SFullPage['demo-container']}>
              <div className={SFullPage['demo-list']}>
                {data.items.map((item, index) => (
                  <div
                    key={index}
                    className={SFullPage['demo-image']}
                    onClick={() => handleDemoClick(index)}
                  >
                    {current === index && (
                      <div className={SFullPage['image-cover']}></div>
                    )}
                    <Image
                      onLoad={imageLoaded}
                      src={item.before}
                      alt="人像分割demo"
                      width={106}
                      height={106}
                      className={SFullPage['image']}
                    />
                  </div>
                ))}
              </div>
              <div className={SFullPage['demo-show']}>
                <Spin spinning={loading}>
                  <div className={SFullPage['label']}>原图</div>
                  <div
                    className={SFullPage['label']}
                    style={{ left: `${slider}%` }}
                  >
                    效果图
                  </div>
                  <ReactCompareImage
                    leftImage={beforePic}
                    rightImage={afterPic}
                    leftImageCss={{ height: '462px', objectFit: 'contain' }}
                    rightImageCss={{ height: '462px', objectFit: 'contain' }}
                    onSliderPositionChange={sliderChange}
                  />
                </Spin>
              </div>
            </div>
            <div className={SFullPage['operation-container']}>
              <Input
                size="large"
                className={SFullPage['input-url']}
                value={inputUrl}
                onChange={handelChange}
                style={{
                  width: '609px',
                  marginRight: '19px',
                  borderRadius: '4px',
                  height: '42px',
                }}
                addonAfter={<div onClick={onSearch}>检测</div>}
                defaultValue=""
                placeholder="请输入URL"
              />
              <Upload
                showUploadList={false}
                maxCount={1}
                beforeUpload={beforeUpload}
                customRequest={(f) => getImage(f)}
                accept="image/png, image/jpeg, image/jpg, image/bmp"
              >
                <Button
                  size="large"
                  style={{
                    width: '130px',
                    color: '#fff',
                    borderRadius: '4px',
                    border: '0px',
                    height: '40.14px',
                  }}
                  icon={<UploadOutlined />}
                >
                  本地上传
                </Button>
              </Upload>
            </div>
          </div>
        </div>
      ) : (
        <>
          <div className={SFullPage['section']}>
            <FadeIn>
              <div className={SFullPage['title']}>{data.title}</div>
            </FadeIn>
            <div className={SFullPage['container']}>
              {data.mobileDemos.map((item, index) => {
                return (
                  <div key={index} className={SFullPage['image']}>
                    <Image
                      src={item}
                      width={382}
                      height={240}
                      alt="移动端人像分割demo"
                    />
                  </div>
                );
              })}
              <div className={SFullPage['desc']}>
                识别图像中的人体轮廓，将其与背景分离，可应用于人体特效制作、图像处理、视频会议虚拟背景等场景
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default ImageDemo;
